export async function persistProfileImageUpdate({
  currentUser,
  userProfile,
  imageUrl,
  updateProfileInFirestore,
  updateProfileImageInAllCollections,
  updateAzureUserProfilePicture,
  onProfilePersisted,
  onAzureSyncError = () => {},
}) {
  const uid = String(currentUser?.uid || "").trim();
  const email = String(currentUser?.email || "").trim();

  if (!uid || !userProfile || !imageUrl) {
    return null;
  }

  // Write ONLY the image field so we don't clobber other (possibly stale) store
  // fields on the server. updateProfileInFirestore uses updateDoc, so the rest of
  // the document is left untouched.
  await updateProfileInFirestore(uid, { profileImage: imageUrl, uid });

  // The store still gets the full merged profile so the avatar update doesn't
  // blank out the other fields locally; onSnapshot reconciles afterwards.
  const updated = { ...userProfile, profileImage: imageUrl, uid };
  if (typeof onProfilePersisted === "function") {
    onProfilePersisted(updated);
  }

  if (typeof updateAzureUserProfilePicture === "function" && email) {
    try {
      Promise.resolve(updateAzureUserProfilePicture(imageUrl, email)).catch(
        onAzureSyncError
      );
    } catch (error) {
      onAzureSyncError(error);
    }
  }

  if (typeof updateProfileImageInAllCollections === "function") {
    await updateProfileImageInAllCollections(uid, imageUrl);
  }

  return updated;
}
